import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase'
import * as moment from 'moment'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-detalles-actividad',
  templateUrl: './modal-detalles-actividad.component.html',
  styleUrls: ['./modal-detalles-actividad.component.scss']
})
export class ModalDetallesActividadComponent implements OnInit {
  modal:any
  trabajador;
  indicetrabajador;
  actividadSeleccionada;
  arrayDeEmpleados;
  dataActividad;
  crearOeditar;
  indiceActividad;

    //----
  actividadParaEditar
  indiceActividadParaEditar

   



  arrayDocumentosTrabajador=[]

  arraydeactividades=[]

  trabajoenalturas={descripcionTarea:'',vencimientoCertAlturas:'', urlCertificado:'', alturamaxima:'',vencimientoCertMedico:'',urlCertificadoMedico:'',solicitante:'',lineaAaislar:'',barrerasFisicas:'',actividadesTraslapantes:'',controlesManos:'',sintomas:[],situaciones:[], }
  trabajoencaliente={descripcionTarea:'',medidasPrevencion:'', areadetrabajo:[],resultadosMonitoreo:'',lineaAaislar:'',barrerasFisicas:'',actividadesTraslapantes:'',controlesManos:'',sintomas:[],situaciones:[]}
  levantamientomecanico={descripcionTarea:'',vencimientoCertMeca:'', urlCertificadoIzaje:'',plandeizaje70:'', lineaAaislar:'',barrerasFisicas:'',actividadesTraslapantes:'',controlesManos:'',sintomas:[],situaciones:[] }
  energiaspeligrosas={descripcionTarea:'',intervencionElectrica:'', certCONTE:'', urlCertCONTE:'',tipoDeEnergias:[],equiposAterrizar:'',equiposABloquear:'',resultadosMonitoreo:'',lineaAaislar:'',barrerasFisicas:'',actividadesTraslapantes:'',controlesManos:'',sintomas:[],situaciones:[]}
  espaciosconfinados={descripcionTarea:'',urlCertificadoConfinados:'',urlCertificadoAptitudConfinados:'',equipos:'',monitoreoO2:'',urlCertificadoEquiposConfinados:'',entrenamientos:[],lineaAaislar:'',barrerasFisicas:'',actividadesTraslapantes:'',controlesManos:'',sintomas:[],situaciones:[]}
  hazmat={descripcionTarea:'',sustanciasQuimicas:'',elementosDemarcacion:'',fichasdeseguridad:'',sustanciasRotuladas:'',matrizCompatibilidad:'',elementosTrasvase:'',elementosEmergencia:[], epp:[], sustAMonitorear:'',monitoreoO2:'',lineaAaislar:'',barrerasFisicas:'',actividadesTraslapantes:'',controlesManos:'',sintomas:[],situaciones:[] }
  supervisionymonitoreo={descripcionTarea:'',tareasSupervision:'',capBolsillo:'',reglasOro:''}
  otros={descripcionTarea:'',actividad1:'',actividad2:'',actividad3:'',actividad4:'',lineaAaislar:'',barrerasFisicas:'',actividadesTraslapantes:'',controlesManos:'',sintomas:[],situaciones:[]}

  subiendo = false
  changedData=true
  percentage=0;



  herramientasYControlesTrabajoEnAlturas = {
    herramientas: { arneses: 0, andamios: 0, eslingas: 0, eslingaDePosicionamiento: 0, cascos: 0, tieOff: 0, poleas: 0, descendedor: 0, gibbs: 0, lineaDeVida: 0, arrestador: 0, mosquetones: 0, cuerdas: 0, escaleras: 0, cintaDeAnclaje: 0, pertiga: 0, otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesTrabajoEnCaliente = {
    herramientas: { pulidoras: 0, motosoldadores: 0, esmeriles: 0, plantasElectricas: 0, taladrosPercutores: 0, sierras: 0, motosierras: 0, guadanas: 0, otrosChispas: 0, otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesLevantamientoMecanico = {
    herramientas: { grua: 0, camionBrazoGrua: 0, montacargas: 0, telehandlers: 0, aparejos: 0, gibbs: 0, arrestadores: 0, mosquetones: 0, cuerdas: 0, otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesEnergiasPeligrosas = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesEspaciosConfinados = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  } 

  herramientasYControlesHazmat = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesSupervicionYmonitoreo = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  } 

  herramientasYControlesOtros = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  } 

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.modal=this.activeModal
    this.recuperaDocumentosTrabajador()
  }

  recuperaDocumentosTrabajador(){
    // this.servicioLoadersAlertasService.presentLoading("Cargando documentos...")
    let docref = firebase.firestore().collection("trabajadores").doc(this.trabajador.id)
    docref.get().then((doc)=>{

      this.trabajoenalturas.urlCertificado=doc.data().urlCertificadoAlturas;
      this.trabajoenalturas.urlCertificadoMedico=doc.data().urlCertificadoAptitud;
      this.espaciosconfinados.urlCertificadoAptitudConfinados=doc.data().urlCertificadoAptitudConfinados;
      this.espaciosconfinados.urlCertificadoConfinados=doc.data().urlCertificadoConfinados;
      this.espaciosconfinados.urlCertificadoEquiposConfinados=doc.data().urlCertificadoEquiposConfinados;
      this.levantamientomecanico.urlCertificadoIzaje=doc.data().urlCertificadoIzaje;
      this.energiaspeligrosas.urlCertCONTE=doc.data().urlCertificadoCONTE;
      
    }).then(()=>{
        // this.servicioLoadersAlertasService.loadingController.dismiss()
       
          this.actividadSeleccionada=this.actividadParaEditar.actividad
          this.asignavaloresACampos()
        
        
    }).catch((err)=>{
      // this.servicioLoadersAlertasService.loadingController.dismiss()
      // this.servicioLoadersAlertasService.alerta("error",err)
    })
  }


  asignavaloresACampos(){

    if(this.actividadParaEditar.actividad =='TRABAJO EN ALTURAS'){
      // this.trabajoenalturas=this.dataActividad
      this.trabajoenalturas= this.actividadParaEditar.dataActividad
      this.herramientasYControlesTrabajoEnAlturas=this.actividadParaEditar.herramientasYcontroles
      this.trabajoenalturas.vencimientoCertAlturas = moment(this.trabajoenalturas.vencimientoCertAlturas).format('YYYY-MM-DD')
      this.trabajoenalturas.vencimientoCertMedico = moment(this.trabajoenalturas.vencimientoCertMedico).format('YYYY-MM-DD')
      
    }else
    if(this.actividadParaEditar.actividad == 'TRABAJO EN CALIENTE'){
    //  this.trabajoencaliente=this.dataActividad
      this.trabajoencaliente= this.actividadParaEditar.dataActividad
      this.herramientasYControlesTrabajoEnCaliente = this.actividadParaEditar.herramientasYcontroles
    }else
    if(this.actividadParaEditar.actividad == 'LEVANTAMIENTO MECÁNICO'){
      // this.levantamientomecanico=this.dataActividad
      this.levantamientomecanico=this.actividadParaEditar.dataActividad
      this.herramientasYControlesLevantamientoMecanico = this.actividadParaEditar.herramientasYcontroles
    }else
    if(this.actividadParaEditar.actividad == 'ENERGÍAS PELIGROSAS'){
      // this.energiaspeligrosas=this.dataActividad
      this.energiaspeligrosas=this.actividadParaEditar.dataActividad
      this.herramientasYControlesEnergiasPeligrosas = this.actividadParaEditar.herramientasYcontroles
    }else
    if(this.actividadParaEditar.actividad == 'ESPACIOS CONFINADOS'){
      // this.espaciosconfinados=this.dataActividad
      this.espaciosconfinados=this.actividadParaEditar.dataActividad
      this.herramientasYControlesEspaciosConfinados = this.actividadParaEditar.herramientasYcontroles
    }else
    if(this.actividadParaEditar.actividad == 'HAZMAT'){
      // this.hazmat=this.dataActividad
      this.hazmat=this.actividadParaEditar.dataActividad
      this.herramientasYControlesHazmat = this.actividadParaEditar.herramientasYcontroles
    }else
    if(this.actividadParaEditar.actividad == 'TRABAJO EN CALIENTE'){
      // this.trabajoencaliente=this.dataActividad
      this.trabajoencaliente=this.actividadParaEditar.dataActividad
      this.herramientasYControlesTrabajoEnCaliente = this.actividadParaEditar.herramientasYcontroles
    }else
    if(this.actividadParaEditar.actividad == 'SUPERVISIÓN Y MONITOREO'){
      // this.supervisionymonitoreo=this.dataActividad
      this.supervisionymonitoreo=this.actividadParaEditar.dataActividad
      this.herramientasYControlesSupervicionYmonitoreo = this.actividadParaEditar.herramientasYcontroles
    }else
    if(this.actividadParaEditar.actividad == 'OTROS'){
      // this.otros=this.dataActividad
      this.otros=this.actividadParaEditar.dataActividad
      this.herramientasYControlesOtros = this.actividadParaEditar.herramientasYcontroles
    }

}


}//fin de clase
